// 中转统一管理所有 api 用于绑定在 vue原型
import api from "./api";

export default {
  ...api,
};
